import { useSprintDurationFeatureFlag } from 'featureFlags/hooks/useSprintDurationFeatureFlag';

/**
 * Adjusts the weekly frequency array length to match sprintDuration FF.
 *
 * Note: The challenge creational API endpoints (create/edit) are not synchronized with sprintDuration FF.
 * When sending a weekly array of length 5, the backend automatically extends it to 6 items
 * by duplicating the last value. This hook ensures we only use the correct number of items
 * based on the sprintDuration FF setting.
 */
export const useAdjustWeeklyFrequency = (): ((
  weeklyFrequency: number[]
) => number[]) => {
  const sprintDuration = useSprintDurationFeatureFlag();

  return (weeklyFrequency: number[]): number[] => {
    return weeklyFrequency.slice(0, sprintDuration);
  };
};
